import { ICodingSpriteType } from 'store'

const getScratchAssetUri = (asset: string, type: ICodingSpriteType): string => {
    if(type === 'mit') return `https://cdn.assets.scratch.mit.edu/internalapi/asset/${asset}/get/`;
    if(type === 'scratchlink') return `${window.location.origin}/jsscratchAssets/${asset}`;
    return asset;
}

export default getScratchAssetUri;